import React from 'react';

export default function Title({children,props}) {
    return (
    <h2 style={{fontFamily: 'Fugaz One', fontSize: '30px', maxWidth:'1000px'}}>{children}</h2>
    );
} 